import { Flex } from './styles/Flex.style';
import { StyledFooter } from './styles/Footer.style';
import SocialIcons from './SocialIcons';
import { FaHome, FaPhoneAlt, FaMailBulk } from 'react-icons/fa';

export default function Footer() {
	return (
		<StyledFooter>
			<Flex>
				{/* <img src='./images/safari-logo.png' alt='' /> */}
				<ul>
					<h2>Safari ICT</h2>
					<li>
						<a href='https://goo.gl/maps/d4ctU2QZ3VCv9Nfn9' alt=''>
							<i>
								<FaHome />{' '}
							</i>
							Bole, Addis Ababa, Ethiopia
						</a>
					</li>

					<li>
						<a href='tel:0911367271' alt=''>
							<i>
								<FaPhoneAlt />{' '}
							</i>
							Call Us at +251-911-3672 71
						</a>
					</li>
					<li>
						<a href='mailto:info@safari-ict.com' alt=''>
							<i>
								<FaMailBulk />
							</i>
							Drop us email info@safari-ict.com
						</a>
					</li>
				</ul>
				<ul>
					<div id='mc_embed_signup'>
						<form
							action='https://safari-ict.us10.list-manage.com/subscribe/post?u=dfb3a6b0ea5008849b3667cfe&amp;id=59c099ea26'
							method='post'
							id='mc-embedded-subscribe-form'
							name='mc-embedded-subscribe-form'
							className='validate'
							target='_blank'
							noValidate
						>
							<div id='mc_embed_signup_scroll'>
								<label htmlFor='mce-EMAIL'>Subscribe</label>
								<input
									type='email'
									defaultValue=''
									name='EMAIL'
									className='email'
									id='mce-EMAIL'
									placeholder='email address'
									required
								/>

								<div
									style={{ position: 'absolute', left: '-5000px' }}
									aria-hidden='true'
								>
									<input
										type='text'
										name='b_dfb3a6b0ea5008849b3667cfe_59c099ea26'
										tabIndex='-1'
										defaultValue=''
									/>
								</div>
								<div className='clear'>
									<input
										type='submit'
										defaultValue='Subscribe'
										name='subscribe'
										id='mc-embedded-subscribe'
										className='button'
									/>
								</div>
							</div>
						</form>
					</div>
				</ul>

				{/* Social Icon */}
				<SocialIcons />
			</Flex>

			<p>&copy; 2021 Safari, All rights reserved.</p>
		</StyledFooter>
	);
}
